import {AdminComponent} from "./AdminComponent";
import React, {ReactElement} from "react";
import {TBody} from "./Table/TBody";
import {SysButton} from "./Elements/SysButton";
import {Util} from "./Util";

export abstract class ListComponent extends AdminComponent {
    protected count: number = 0;
    protected limit: number = 100;
    protected isLoading: boolean = false;

    constructor(props: any) {
        super(props);
        this.state = {isLoading: false, page: 0, count: 0, itemsCount: 0, items: [], item: null};
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    protected afterSetStateFinished() {
    }

    handleSubmit(event: any) {
        event.preventDefault();
        if (this.isLoading) {
            return;
        }

        let search = [], data = this.getParsedFormData();

        //@ts-ignore
        for (let key in data) {
            if (data[key]) {
                search.push(`${key}=${data[key]}`);
            }
        }

        // @ts-ignore
        document.querySelector('main').removeEventListener("scroll", this.handleScroll);

        window.location.assign(`#${search.join('&')}`);

        this.setState({isLoading: true, page: 0, count: 0, itemsCount: 0, items: [], item: null}, () => {

            // @ts-ignore
            document.querySelector('main').addEventListener("scroll", this.handleScroll);

            this.fetchData(data).then((r: { list: object[]; count: number; } | any) => {

                this.setState({
                    isLoading: false,
                    page: this.state.page + 1,
                    count: r.count,
                    itemsCount: r.list?.length || 0,
                    items: r.list,
                    item: r.item || this.state?.item || null,
                    error: r.error || null
                });
            }, () => {
                this.afterSetStateFinished();
            });
        });
    }

    protected toggleSearchBar(e: any) {
        e.preventDefault();
        const searchBar: HTMLElement = (document.querySelector('.search-bar') as HTMLElement);
        if (searchBar.classList.contains('hidden')) {
            searchBar.classList.remove('hidden');
        } else {
            searchBar.classList.add('hidden');
        }
    }

    protected handleScroll = () => {
        if (this.isLoading) {
            return;
        }

        const main = document.querySelector('main') as HTMLElement;

        const {scrollHeight, clientHeight, scrollTop} = main;

        if (scrollHeight <= clientHeight + scrollTop + 2) {

            this.setState({isLoading: true}, () => {

                let data = this.getParsedFormData();

                this.fetchData(data).then((r: { list: object[]; count: number; } | any) => {

                    if (r.list.length < this.limit) {
                        main.removeEventListener("scroll", this.handleScroll);
                    }

                    this.setState({
                        isLoading: false,
                        page: this.state.page + 1,
                        count: r.count,
                        itemsCount: r.list?.length || 0,
                        items: [...this.state.items, ...r.list],
                        item: r.item || this.state?.item || null
                    }, () => {
                        this.afterSetStateFinished();
                    });
                });
            });
        }
    };

    setState(state: object | any, callback?: () => void): void {
        this.isLoading = state.isLoading;
        if (callback) {
            super.setState(state, callback);
            return;
        }
        super.setState(state)
    }

    componentDidMount() {
        if (this.isLoading) {
            return;
        }

        this.initTableHead();
        this.setState({isLoading: true}, () => {

            (document.querySelector('main') as HTMLElement).addEventListener("scroll", this.handleScroll);

            let data = this.getParsedFormData();
            this.fetchData(data).then((r: { list: object[]; count: number; } | any) => {
                this.setState({
                    isLoading: false,
                    page: this.state.page + 1,
                    count: r.count,
                    itemsCount: r.list?.length || 0,
                    items: r.list,
                    item: r.item || this.state?.item || null
                }, () => {
                    this.afterSetStateFinished();
                });
            });
        });
    }

    componentWillUnmount() {
        (document.querySelector('main') as HTMLElement).removeEventListener("scroll", this.handleScroll);
    }

    protected navigate(event: any, url: string) {
        if (event?.button === 0) {
            window.location.assign(url);
            return;
        }

        if (event?.button === 1) {
            let a = document.createElement('a');

            a.setAttribute('href', url);
            a.setAttribute('style', 'display:none');
            a.setAttribute('target', '__blank');

            (document.querySelector('body') as HTMLBodyElement).append(a);
            a.click();
            a.remove();
        }
    }

    protected getFormData(): {} {
        let list = window.location.hash.substring(1).split('&'), params = {};
        for (let i in list) {
            //@ts-ignore
            let parts = decodeURIComponent(list[i]).split('=');
            // @ts-ignore
            params[parts[0]] = parts[1] || '';
        }
        return params;
    }

    protected fetchData(data: { [key: string]: string } | any): Promise<Response> {

        data.page = this.state.page.toString();
        data.limit = this.limit.toString();

        let responseUrl = this.getRequestUrl();

        if (this.getRequestMethod() === 'GET') {
            let search = [];
            for (let key in data) {
                data[key] && search.push(`${key}=${data[key]}`);
            }
            responseUrl = `${responseUrl}?${search.join('&')}`;
            data = null;
        }

        return this.request.fetch(responseUrl, data, {method: this.getRequestMethod()}).catch(error => {
            this.onError(error);
            console.error(error);
            // @ts-ignore
            return this.request.response.json();
        });
    }

    exportTableData(url: string) {
        let form = document.createElement('form');

        form.setAttribute('style', 'display:none');
        form.setAttribute('action', this.request.base + url);
        form.setAttribute('method', 'POST');
        // form.setAttribute('target', '__blank');

        const data = new FormData((document.querySelector('form.x-form') as HTMLFormElement));
        //@ts-ignore
        const dataObject = Object.fromEntries(data.entries());

        for (let name in dataObject) {
            let input = document.createElement('input');
            input.setAttribute('type', 'hidden');
            input.setAttribute('name', name);
            input.setAttribute('value', dataObject[name].toString());
            form.append(input);
        }

        let input = document.createElement('input');
        input.setAttribute('type', 'hidden');
        input.setAttribute('name', 'Authorization');
        input.setAttribute('value', "Bearer " + this.user.getToken());
        form.append(input);

        (document.querySelector('body') as HTMLBodyElement).append(form)
        form.submit();
        form.remove();
    }

    initTableHead() {

        document.querySelectorAll('thead th.sortable').forEach(th => {
            th.addEventListener("click", (event) => {
                //@ts-ignore
                let icon = event.target.tagName === 'I' ? event.target : event.target.querySelector('.bi'), sortWay;

                if (icon === null) {
                    document.querySelectorAll('thead .bi').forEach(i => {
                        i.remove();
                    });
                    icon = document.createElement('i');
                    icon.classList.add('bi');
                    icon.classList.add('bi-sort-down');
                    //@ts-ignore
                    event.target.append(icon);
                }

                if (icon.classList.contains('bi-sort-down')) {
                    icon.classList.add('bi-sort-down-alt');
                    icon.classList.remove('bi-sort-down');
                    sortWay = ':a';
                } else {
                    icon.classList.add('bi-sort-down');
                    icon.classList.remove('bi-sort-down-alt');
                    sortWay = ':d';
                }

                //@ts-ignore
                document.querySelector('.x-form input[name="sort"]').value = event.target.getAttribute('data-sortKey') + sortWay;

                //@ts-ignore
                document.querySelector('.x-form button[type="submit"]').click();
            });
        });

        let list = window.location.hash.substring(1).split('&');

        for (let i in list) {
            let parts = decodeURIComponent(list[i]).split('=');
            let name = parts[0];

            // if (document.querySelector(`[name="${name}"]`)) {
            //     //@ts-ignore
            //     document.querySelector(`[name="${name}"]`).value = parts[1] || '';
            // }

            if (name === 'sort' && parts[1]) {
                let sort = parts[1],
                    sortName = sort.substring(0, sort.length - 2),
                    sortWay = sort.substring(sort.length - 2);

                if (document.querySelector('thead th .bi') &&
                    document.querySelector(`thead th[data-sortkey="${sortName}"]`)) {
                    (document.querySelector('thead th .bi') as HTMLElement).remove();

                    let icon = document.createElement('i');

                    icon.classList.add('bi');
                    icon.classList.add('bi-sort-down' + (sortWay === ':a' ? '-alt' : ''));

                    (document.querySelector(`thead th[data-sortkey="${sortName}"]`) as HTMLElement).append(icon);
                }
            }
        }
    }

    protected getParsedFormData(): object | any {
        return Object.fromEntries((new FormData(document.querySelector('form.x-form') as HTMLFormElement)).entries());
    }

    protected getRequestMethod(): string {
        const form = document.querySelector('form.x-form') as HTMLFormElement;
        if (form.hasAttribute('method')) {
            return form.getAttribute('method') || 'POST';
        }
        return 'POST';
    }

    protected listOfSearchParams(params: any): ReactElement {
        let paramsList: any = [{key: 'delete-all-search-criteria', value: true}];
        for (const key in params) {
            if (key === 'sort') {
                continue;
            }
            paramsList.push({key: key, value: params[key]});
        }
        if (paramsList.length === 1 || paramsList[1].key === '') {
            return (<></>);
        }
        if (paramsList.length === 2) {
            delete paramsList[0];
        }
        const dictionary = this.dictionary;
        return (
            <div className="row details deleteSearchList" style={{marginBottom: '10px'}}>
                <div key={TBody.index++}>
                    <h6>{this.dictionary.get['search-criteria']}</h6>
                </div>
                {paramsList.map(function (elem: any) {
                    if (elem.key === 'delete-all-search-criteria') {
                        return (
                            <div key={TBody.index++}>
                                <SysButton type={'SignTurnRightFill'} className="deleteSearch deleteSearchAll"
                                           onClick={Util.removeAllSearch}>{dictionary.get['delete-all']}</SysButton>
                            </div>);
                    }
                    return (
                        <div key={TBody.index++}>
                            <SysButton type={'SignTurnRightFill'} data-id={elem.key} className="deleteSearch"
                                       onClick={Util.removeSearch}>{dictionary.get[elem.key]}: {elem.value}</SysButton>
                        </div>);
                })}
            </div>
        );
    }
}
